import React, { useEffect, useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import interactionPlugin from "@fullcalendar/interaction";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import ".../../../src/index.scss";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BalanceIcon from "@mui/icons-material/Balance";
import GroupsIcon from "@mui/icons-material/Groups";
import { connect } from "react-redux";
import {
  Box,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import { makeStyles, withStyles } from "@mui/styles";
import moment from "moment";

import {
  ArrowBackIosNew,
  ArrowForwardIos,
  FiberManualRecord,
  Lock,
} from "@mui/icons-material";
import { shallowEqual, useSelector } from "react-redux";
import { isNull, isUndefined } from "lodash";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import "@fullcalendar/resource-timeline/main.min.css";
import { useHistory } from "react-router-dom";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import { getAllRoomTypess } from "../../RevenueManagement/RatePlans/apis/RatePlanApis";
import { BookingDataModel } from "../../CalendarPage/models/BookingDataModel";
import DimmingDotsLoader from "../../CalendarPage/Views/LoaderCustom";
import { getRentalBookingsData } from "../../CalendarPage/api/ReservationApi";
import {
  channelLogoMap,
  dateFormat,
  getSlotType,
  multiOptions,
  navigationParamsForCalendar,
  views,
} from "../../CalendarPage/constants/Calendar-constants";
import NewRentalBookingDataModal from "../../CalendarPage/models/NewRentalBookingDataModal";
import CreateBooking from "../../Shops/RentalSpace/SpaceModules/CreateBooking";
import BlockRoom from "./SpaceModules/BlockRoom";
import ViewBooking from "./SpaceModules/ViewBooking";
import CreateGroupBooking from "./SpaceModules/CreateGroupBooking";

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    padding: 0,
  },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  drawer: {
    flexShrink: 0,
    width: "95%",
  },
  drawers: {
    flexShrink: 0,
    width: "55%",
  },
  drawerPaper: {
    width: "95%",
  },
  drawerPapers: {
    width: "55%",
  },
}));

const SpaceCalendar = ({ singleSpaceInfo, gridRefresh }) => {
  const { hotel } = useSelector(
    ({ auth }) => ({
      hotel: auth.selectedHotel,
    }),
    shallowEqual
  );

  const history = useHistory();
  const [subUser, setsubUser] = useState(hotel?.accessControl?.ADMINRIGHTS);
  const [hotelemail, sethotelemail] = useState(
    hotel?.accessControl?.hotel?.hotel_email
  );

  const hotelSlot = getSlotType("PURE_HOURLY");

  const hotelId = hotel.hotelId;
  const calendarRef = useRef(null);
  const navigationParams = Object.assign(navigationParamsForCalendar);
  navigationParams.hotelId = hotelId;
  let [actionType, setActionType] = useState("");
  let [showModal, setShowModal] = useState({});
  let [show, setShow] = useState(false);
  let [initialData, setInitialData] = useState(new BookingDataModel({}));
  let [calendarApi, setCalendarApi] = useState(null);
  let [loading, setLoading] = useState(false);
  const [showRoomView, setshowRoomView] = useState(false);
  // let [snackbar, setSnackbar] = useState(false);
  const [rooms, setRooms] = useState([
    { text: "Available Rooms", id: "availableRooms" },
    { text: "Blocked Rooms", id: "blockedRooms" },
    { text: "Dirty Rooms", id: "dirtyRooms" },
    { text: "Clean Rooms", id: "cleanRooms" },
    { text: "Occupied Rooms", id: "bookedRooms" },
    { text: "All", id: "All" },
    { text: "Unselect", id: "Unselect" },
  ]);
  const [selectedRoom, setSelectedRoom] = useState([]);
  const [today, setToday] = useState(new Date());
  const [roomNumbers, setRoomNumbers] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [multiOption, setMultiOption] = useState("");

  const [showUnassigned, setShowUnassigned] = useState(false);

  const [showRoomName, setshowRoomName] = useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const [dirtyRoomId, setdirtyRoomId] = useState("");

  const [whiteLabelled, setWhiteLabelled] = useState("ENABLED");

  const [scrollPosition, setScrollPosition] = useState(0);

  const whitlableArrMap = [
    "STAYFLEXI_OD",
    "STAYFLEXI_OM",
    "STAYFLEXI MOBILE",
    "STAYFLEXI_GHA",
    "STAYFLEXI_BE",
    "STAYFLEXI_MOBILE",
  ];

  const classes = useStyles();

  // Creating a new event when selecting in a empty space
  const handleDateSelect = (data) => {
    console.log("Onclick event", data);
    if (data.event.extendedProps.status === "COMBO") return;
    if (data.event.extendedProps.status === "BLOCKED")
      setActionType("edit-blocked");
    else setActionType("edit");
    setScrollPosition(window.pageYOffset);
    setShowModal(data);
    setShow(true);
  };

  // When event position changes for Drag and drop and extension
  const handleDragStop = (data) => {
    if (
      data.event.getResources()[0].id !== data.oldEvent.getResources()[0].id &&
      data.oldEvent.startStr !== data.event.startStr &&
      data.oldEvent.endStr !== data.event.endStr
    ) {
      data.revert();
      return;
    }
    setShowModal(data);
    setShow(true);
  };

  // Closing the modal for creating new event
  const handleAddEventSidebar = () => {
    setShow(!show);
    setShowModal(null);

    setTimeout(() => {
      window.scrollTo(0, scrollPosition);
    }, 700);
  };

  // Opening a modal for new event in the empty boxes
  const addNew = (data) => {
    setActionType("add");
    setScrollPosition(window.pageYOffset);
    setShowModal(data);
    setShow(true);
  };

  // Adding the new event to the calendar
  const setNewData = (obj, val) => {
    if (!val) {
      calendarApi.addEvent(obj);
      if (calendarApi !== null) {
        calendarApi.refetchEvents();
      }
    }

    // if (val === "success") {
    //   setSnackbar(true);
    // }
    handleAddEventSidebar();
  };

  const checkForEmptyCalendar = () => {
    if (isNull(calendarApi)) {
      return false;
    }
    if (isUndefined(calendarApi.view)) {
      return false;
    }

    return true;
  };

  const fetchBookingDataWithParams = async (tempData, type) => {
    console.log("2", tempData);

    calendarApi.removeAllEvents();
    initialData.roomsData = [];
    initialData.bookingData = [];

    let params = {
      nonRentalIdsSort: true,
      hotelId: hotelId,
      startDate: moment(tempData.startDate, "DD-MM-YYYY HH:mm:ss").format(
        "YYYY-MM-DD"
      ),
      nonRentalTypes: [singleSpaceInfo?.id],
      numOfDays: 1,
      availableNonRentals: true,
      blockedNonRentals: true,
      bookedNonRentals: true,
      clusterNonRentals: true,
    };
    setLoading(true);
    const data = await getRentalBookingsData(params, history);
    setLoading(false);
    let resp;
    if (type === "month" || sessionStorage.getItem("types") === "month") {
      resp = new NewRentalBookingDataModal(
        data,
        params.viewType,
        "PURE_HOURLY"
      );
    } else {
      resp = new NewRentalBookingDataModal(
        data,
        params.viewType,
        "PURE_HOURLY"
      );
    }
    setRoomNumbers(resp.roomsData);
    setInitialData(resp);
  };

  const fetchBookingData = async () => {
    console.log("1");
    try {
      setLoading(true);
      // let temp = Object.assign(navigationParams);

      let temp = {
        nonRentalIdsSort: true,
        hotelId: hotelId,
        startDate: moment().format("YYYY-MM-DD"),
        nonRentalTypes: [singleSpaceInfo?.id],
        numOfDays: 1,
        availableNonRentals: true,
        blockedNonRentals: true,
        bookedNonRentals: true,
        clusterNonRentals: true,
      };

      const data = await getRentalBookingsData(temp, history);
      setLoading(false);
      const resp = new NewRentalBookingDataModal(
        data,
        "resourceTimelineDay",
        "PURE_HOURLY"
      );
      setRoomNumbers(resp.roomsData);
      // setOriginalAllRoomInfo(data.allRoomReservations.singleRoomReservations);
      setInitialData(resp);
    } catch (er) {
      console.log(er);
      setLoading(true);
    }
  };

  const getParamsForView = (val) => {
    let title = calendarApi?.view?.type;

    let currentDate = calendarApi?.getDate();

    let tempParams = Object.assign(navigationParams);
    if (views[title] === 30) {
      if (val === "subtract") {
        currentDate.setDate(currentDate.getDate() - views[title]);
      }
      if (val === "add") {
        currentDate.setDate(currentDate.getDate() + views[title]);
      }
    } else {
      if (val === "subtract") {
        currentDate.setDate(currentDate.getDate() - views[title]);
      }
      if (val === "add") {
        currentDate.setDate(currentDate.getDate() + views[title]);
      }
    }

    tempParams.viewType = title;
    tempParams.numOfDays = views[title];
    tempParams.availableRooms = selectedRoom?.includes("availableRooms");
    tempParams.blockedRooms = selectedRoom?.includes("blockedRooms");
    tempParams.dirtyRooms = selectedRoom?.includes("dirtyRooms");
    tempParams.cleanRooms = selectedRoom?.includes("cleanRooms");
    tempParams.bookedRooms = selectedRoom?.includes("bookedRooms");
    tempParams.startDate = moment(currentDate)
      .set({ hour: 0, minute: 0, second: 0 })
      .format(dateFormat);
    const temporary = [];
    if (selectedRoom.some((e) => e.id === "All") || selectedRoom.length === 0) {
      tempParams.roomTypes = rooms.forEach((e) => {
        if (e.id !== "All" && e.id !== "Unselect") temporary.push(e.id);
      });
    } else {
      selectedRoom.forEach((room) => {
        temporary.push(room.id);
      });
      tempParams.roomTypes = temporary;
    }
    tempParams.clusterRooms = sessionStorage.getItem("showRoomName")
      ? sessionStorage.getItem("showRoomName")
      : false;
    return tempParams;
  };

  const getRoomsData = async () => {
    const resp = await getAllRoomTypess();
    const temp_rooms = [];

    for (const [key, value] of Object.entries(resp)) {
      rooms.push({ text: value, id: key });
    }
    setRooms(rooms);
    setshowRoomView(Object.entries(resp).length > 1);
    setSelectedRoom(rooms.filter((e) => e.text === "All"));
  };
  // To detect the changes in the calendar and re-rendering
  useEffect(() => {
    if (calendarApi === null) {
      getRoomsData();
      fetchBookingData();
      setCalendarApi(calendarRef.current.getApi());
    }
  }, [calendarApi]);

  useEffect(() => {
    if (gridRefresh) {
      getRoomsData();
      fetchBookingData();
      setCalendarApi(calendarRef.current.getApi());
    }
  }, [gridRefresh]);

  const getSource = (source) => {
    if (source !== undefined) {
      if (channelLogoMap[source] === undefined) return "";
      return channelLogoMap[source];
    }
  };

  useEffect(() => {
    if (
      calendarApi !== null &&
      calendarApi !== undefined &&
      calendarApi !== ""
    ) {
      if (
        sessionStorage.getItem("types") !== null &&
        sessionStorage.getItem("types") !== undefined &&
        sessionStorage.getItem("types") !== ""
      ) {
      } else {
        sessionStorage.setItem("types", "day");
      }
    }
    setScrollPosition(window.pageYOffset);
  }, [sessionStorage.getItem("types"), calendarApi]);

  // const [checked, setChecked] = useState(false);

  const handleChangeName = (event) => {
    // setChecked(event.target.checked);
    if (event.target.checked) {
      let tempData = getParamsForView(sessionStorage.getItem("types"));
      tempData.clusterRooms = true;
      fetchBookingDataWithParams(tempData, sessionStorage.getItem("types"));
    } else {
      let tempData = getParamsForView(sessionStorage.getItem("types"));
      tempData.clusterRooms = false;
      fetchBookingDataWithParams(tempData, sessionStorage.getItem("types"));
    }

    setshowRoomName(event.target.checked);
    sessionStorage.setItem("showRoomName", event.target.checked);
  };

  useEffect(() => {
    if (
      sessionStorage.getItem("showRoomName") === undefined ||
      sessionStorage.getItem("showRoomName") === null ||
      sessionStorage.getItem("showRoomName") === "" ||
      sessionStorage.getItem("types") === undefined ||
      sessionStorage.getItem("types") === null ||
      sessionStorage.getItem("types") === ""
    ) {
      setshowRoomName(false);
    } else {
      const data =
        sessionStorage.getItem("showRoomName") === "true" ? true : false;

      if (
        calendarApi !== undefined &&
        calendarApi !== null &&
        calendarApi !== ""
      ) {
        if (data) {
          let tempData = getParamsForView(sessionStorage.getItem("types"));
          tempData.clusterRooms = true;
          fetchBookingDataWithParams(tempData, sessionStorage.getItem("types"));
        } else {
          let tempData = getParamsForView(sessionStorage.getItem("types"));
          tempData.clusterRooms = false;
          fetchBookingDataWithParams(tempData, sessionStorage.getItem("types"));
        }
      }

      setshowRoomName(data);
    }
    setScrollPosition(window.pageYOffset);
  }, [
    sessionStorage.getItem("showRoomName"),
    sessionStorage.getItem("types"),
    calendarApi,
  ]);
  const [myCounter, setmyCounter] = useState(0);
  useEffect(() => {
    if (calendarApi && today && myCounter === 0) {
      calendarApi.gotoDate(today);
      let tempData = getParamsForView("date");
      fetchBookingDataWithParams(tempData);
      setmyCounter(1);
    }
  }, [today, calendarApi]);

  const handleMultiOperation = (e) => {
    console.log("handleMultiOperation", e);
    setMultiOption(e?.target?.value);
    setOpenDrawer(true);
  };

  return (
    <Box>
      <Grid
        container
        sx={{ "&:lastChild": 3, paddingTop: "0px" }}
        width="100%"
        height="100%"
        spacing={2}
      >
        <Grid item container xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box>
              <IconButton
                sx={{ overflow: "auto" }}
                style={{ border: "none" }}
                onClick={() => {
                  let tempData = getParamsForView("subtract");
                  fetchBookingDataWithParams(tempData);
                  calendarApi.prev();
                  setShowUnassigned(false);
                }}
              >
                <ArrowBackIosNew style={{ color: "#36454F" }} />
              </IconButton>
            </Box>
            <Box>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  value={today}
                  onChange={(newValue) => {
                    setToday(newValue);
                    calendarApi.gotoDate(newValue);
                    let tempData = getParamsForView("date");
                    fetchBookingDataWithParams(tempData);
                    setShowUnassigned(false);
                  }}
                  renderInput={({ inputRef, inputProps, InputProps }) => (
                    <>
                      {checkForEmptyCalendar() &&
                        calendarApi.view.type === "resourceTimelineDay" && (
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Typography variant="h5">
                              {checkForEmptyCalendar()
                                ? calendarApi.view.title
                                : moment(new Date()).format("MMMM D, YYYY")}
                            </Typography>

                            <div ref={inputRef} {...inputProps}>
                              {InputProps?.endAdornment}
                            </div>
                          </Box>
                        )}

                      {checkForEmptyCalendar() &&
                        calendarApi.view.type !== "resourceTimelineDay" && (
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <div ref={inputRef} {...inputProps}>
                              {/* Render the calendar icon with increased size */}
                              {InputProps?.endAdornment && (
                                <Box sx={{ fontSize: 32 }}>
                                  {InputProps.endAdornment}
                                </Box>
                              )}
                            </div>
                          </Box>
                        )}
                    </>
                  )}
                ></DatePicker>
              </LocalizationProvider>
            </Box>
            <Box>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                }}
              >
                <FormControl
                  fullWidth
                  size="small"
                  style={{ width: "10rem", marginLeft: "1rem" }}
                >
                  <InputLabel
                    style={{ width: "10rem" }}
                    id="demo-simple-select-label"
                  >
                    {"Create"}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    onChange={handleMultiOperation}
                    style={{ marginLeft: "0rem", width: "10rem" }}
                    className="mr-4"
                    label={"Create"}
                    size="small"
                    value={multiOption}
                  >
                    <MenuItem value={"booking"}> Create booking</MenuItem>
                    {+singleSpaceInfo?.globalNonRentalTypeId === 4 && (
                      <MenuItem value={"groupBooking"}>
                        {" "}
                        Create group booking
                      </MenuItem>
                    )}
                    {/* <MenuItem value={"blocking"}>Block space</MenuItem> */}
                  </Select>
                </FormControl>
                <IconButton
                  onClick={() => {
                    let tempData = getParamsForView("add");
                    fetchBookingDataWithParams(tempData);
                    calendarApi.next();
                    setShowUnassigned(false);
                  }}
                >
                  <ArrowForwardIos style={{ color: "#36454F" }} />
                </IconButton>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item display={"inline-flex"} xs={12} height="100%">
          {loading && (
            <Grid
              item
              xs={12}
              position={"fixed"}
              top="50%"
              left="50%"
              container
            >
              <DimmingDotsLoader />
            </Grid>
          )}
          <div style={{ width: "100%" }} className="custom-resource-calendar">
            <FullCalendar
              // nowIndicator={true}
              refetchResourcesOnNavigate={true}
              eventResizableFromStart={true}
              resourceAreaWidth={100}
              schedulerLicenseKey="0974064232-fcs-1639721704"
              selectOverlap={true}
              views={{
                resourceTimelineWeek: {
                  nowIndicator: true,
                  titleFormat: { month: "short", day: "2-digit" },
                  contentHeight: "auto",
                  height: "auto",
                  selectOverlap: true,
                  slotLabelDidMount: (el) => {
                    if (
                      el.level === 1 ||
                      el.text === "12am" ||
                      el.text === "8am" ||
                      el.text === "4pm"
                    ) {
                      el.el.className = el.el.className + " dont-display";
                    }
                    if (el.level === 0) {
                      el.el.className = el.el.className + " special-display";
                      el.el.childNodes[0].className =
                        el.el.childNodes[0].className + " spe-height";
                    }
                  },
                  slotLabelWillUnmount: (el) => {
                    if (
                      el.level === 1 ||
                      el.text === "12am" ||
                      el.text === "8am" ||
                      el.text === "4pm"
                    ) {
                      el.el.className = el.el.className + " dont-display";
                    }
                    if (el.level === 0) {
                      el.el.className = el.el.className + " special-display";
                      el.el.childNodes[0].className =
                        el.el.childNodes[0].className + " spe-height";
                    }
                  },
                  slotMinTime: "00:00:00",
                  slotMaxTime: "24:00:00",
                  slotDuration: hotelSlot,
                  //   ? "23:00:00" : hourToString[initialData.checkInTimes[initialData.checkInTimes.length - 1]].text,
                  slotLabelContent: (day) => {
                    if (day.level === 0) {
                      return (
                        <span className="d-flex">
                          <Tooltip
                            arrow
                            title={`Go to ${day.date.toDateString()}`}
                          >
                            <Typography
                              onClick={(e) => {
                                e.stopPropagation();
                                calendarApi.changeView("resourceTimelineDay");
                                setToday(day.date);
                                calendarApi.gotoDate(day.date);
                                let tempData = getParamsForView("date");
                                fetchBookingDataWithParams(tempData);
                              }}
                              sx={{
                                color: "#2C3E50 !important",
                                display: "flex",
                                paddingRight: "4px",
                                fontWeight: 600,
                              }}
                              component={"div"}
                              color={"inherit"}
                            >
                              {day.date.toDateString()}
                            </Typography>
                          </Tooltip>
                        </span>
                      );
                    } else {
                      return (
                        <Typography sx={{ color: "#2C3E50 !important" }}>
                          {day.text}
                        </Typography>
                      );
                    }
                  },
                  eventDidMount: (eve) => {
                    if (
                      eve.event.extendedProps.status === "CONFIRMED" ||
                      eve.event.extendedProps.status === "ADMIN_CONFIRMED"
                    ) {
                      var div = document.createElement("div");
                      div.className = "fc-event-resizer fc-event-resizer-start";
                      var div1 = document.createElement("div");
                      div.className = "fc-event-resizer fc-event-resizer-end";
                      eve.el.appendChild(div);
                      eve.el.appendChild(div1);
                    }
                  },
                  eventContent: (arg) => {
                    const start = moment(
                      arg.event._instance.range.start
                    ).format("DD-MM-YYYY");
                    const end = moment(arg.event._instance.range.end).format(
                      "DD-MM-YYYY"
                    );

                    let days = moment(arg.event._instance.range.end).diff(
                      moment(arg.event._instance.range.start),
                      "days"
                    );

                    let len = arg.event.title.length;
                    let finalTital;
                    if (days === 0 && len > 10) {
                      finalTital = arg.event.title.substring(0, 6) + "...";
                    } else if (days === 1 && len > 30) {
                      finalTital = arg.event.title.substring(0, 25) + "...";
                    } else if (days === 2 && len > 45) {
                      finalTital = arg.event.title.substring(0, 40) + "...";
                    } else {
                      finalTital = arg.event.title;
                    }
                    return (
                      <div>
                        <div>
                          <div
                            style={{
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              fontWeight: 600,
                              fontSize: "1rem",
                              paddingLeft: "1rem",
                              color: "#2C3F51",
                            }}
                          >
                            {arg.event.extendedProps.locked_status ===
                              "LOCKED" && (
                              <Lock
                                color={
                                  arg.event.extendedProps.status ===
                                    "CHECKED_OUT" ||
                                  arg.event.extendedProps.status ===
                                    "CONFIRMED" ||
                                  arg.event.extendedProps.status === "DONE"
                                    ? "primary"
                                    : "inherit"
                                }
                                sx={{ marginRight: 1 }}
                              />
                            )}

                            {finalTital}

                            {
                              whiteLabelled === "ENABLED"
                                ? getSource(
                                    arg.event.extendedProps.bookingSource
                                  )?.includes(".png") &&
                                  !whitlableArrMap.includes(
                                    arg.event.extendedProps.bookingSource
                                  ) && (
                                    <img
                                      src={getSource(
                                        arg.event.extendedProps.bookingSource
                                      )}
                                      style={{
                                        height: "2rem",
                                        marginLeft: "10px",
                                        borderRadius: "100%",
                                      }}
                                    />
                                  )
                                : getSource(
                                    arg.event.extendedProps.bookingSource
                                  )?.includes(".png") && (
                                    <img
                                      src={getSource(
                                        arg.event.extendedProps.bookingSource
                                      )}
                                      style={{
                                        height: "2rem",
                                        marginLeft: "10px",
                                        borderRadius: "100%",
                                      }}
                                    />
                                  )
                              // <img
                              //   src={getSource(
                              //     arg.event.extendedProps.bookingSource
                              //   )}
                              //   style={{
                              //     height: "2rem",
                              //     marginLeft: "10px",
                              //     borderRadius: "100%",
                              //   }}
                              // />
                            }

                            {arg.event.extendedProps.segment ===
                              "DIRECT_BILLING" && (
                              <SupportAgentRoundedIcon
                                style={{
                                  marginLeft: "10px",
                                }}
                              />
                            )}
                            {arg.event.extendedProps.balanceDue > 0 && (
                              <BalanceIcon
                                style={{
                                  marginLeft: "10px",
                                  color: arg.event.extendedProps
                                    .highBalanceDueAlertStatus
                                    ? "red"
                                    : "darkcyan",
                                }}
                              />
                            )}
                            {arg.event.extendedProps.bookingNotes === "YES" && (
                              <SpeakerNotesIcon
                                style={{
                                  marginLeft: "10px",
                                  color: "darkcyan",
                                }}
                              />
                            )}
                            {arg.event.extendedProps.groupBooking === true && (
                              <GroupsIcon
                                style={{
                                  marginLeft: "10px",
                                  color: "darkcyan",
                                }}
                              />
                            )}

                            {arg.event.extendedProps.selfServiceStatus ===
                              "REQUESTED" && (
                              <RadioButtonUncheckedIcon
                                style={{
                                  marginLeft: "10px",
                                  color: "darkcyan",
                                }}
                              />
                            )}

                            {arg.event.extendedProps.selfServiceStatus ===
                              "APPROVED" && (
                              <CheckCircleIcon
                                style={{
                                  marginLeft: "10px",
                                  color: "darkcyan",
                                }}
                              />
                            )}
                          </div>
                        </div>
                        {/* </LightTooltip> */}
                      </div>
                    );
                  },
                },
                resourceTimelineDay: {
                  nowIndicator: true,
                  titleFormat: { month: "short", day: "2-digit" },
                  contentHeight: "auto",
                  height: "auto",
                  selectOverlap: false,
                  slotDuration: "01:00:00",
                  slotLabelContent: (data) => {
                    return (
                      <Typography
                        sx={{ color: "#2C3E50 !important", fontWeight: 600 }}
                      >
                        {data.text}
                      </Typography>
                    );
                  },
                  slotLaneContent: (day) => {
                    return (
                      <div>
                        <Typography>{day.time}</Typography>
                      </div>
                    );
                  },
                  eventContent: (arg) => {
                    return (
                      <div>
                        <div
                          style={{
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            fontWeight: 600,
                            fontSize: "1rem",
                            paddingLeft: "1rem",
                            color: "#2C3F51",
                          }}
                        >
                          {arg.event.title}
                        </div>
                      </div>
                    );
                  },
                },
              }}
              droppable={false}
              contentHeight={"auto"}
              height="auto"
              scrollTime={"00:00"}
              forceEventDuration={true}
              firstDay={
                checkForEmptyCalendar()
                  ? calendarApi.getDate().getDay()
                  : new Date().getDay()
              }
              lazyFetching={true}
              plugins={[interactionPlugin, resourceTimelinePlugin]}
              headerToolbar={false}
              resourceLabelContent={(arg) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      cursor: "pointer",
                      color: `${
                        showRoomName
                          ? arg.resource.extendedProps.roomTypeColor ===
                            "#ffffff"
                            ? "black"
                            : arg.resource.extendedProps.roomTypeColor
                          : "black"
                      }`,
                    }}
                    onClick={(e) => {
                      setdirtyRoomId(arg.resource.title);
                      if (
                        arg.resource.extendedProps.dirtyColor === "bg-danger"
                      ) {
                        handleOpen();
                      }
                    }}
                  >
                    <div
                      style={{
                        width: `${
                          arg.resource.extendedProps.dirtyColor === "bg-danger"
                            ? "1em"
                            : "1rem"
                        }`,
                        marginRight: "10px",
                      }}
                    >
                      {arg.resource.extendedProps.dirtyColor ===
                        "bg-danger" && (
                        <FiberManualRecord
                          color="error"
                          fontSize="small"
                          sx={{ ml: 0.5, alignSelf: "center" }}
                        />
                      )}
                    </div>

                    <LightTooltip title={arg.resource.title} arrow>
                      <Typography sx={{ fontWeight: "bold" }}>
                        {arg.resource.extendedProps.roomType}
                      </Typography>
                    </LightTooltip>

                    {showRoomName && (
                      <LightTooltip
                        title={arg.resource.extendedProps.roomType}
                        arrow
                      >
                        <Typography sx={{ ml: 0.5, fontWeight: "bold" }}>
                          {` - ${arg.resource.extendedProps.roomTypeCode}`}
                        </Typography>
                      </LightTooltip>
                    )}
                  </div>
                );
              }}
              eventResizeStart={() => {
                setActionType("extend");
              }}
              eventDragStart={() => {
                setActionType("DragorDrop");
              }}
              initialView={"resourceTimelineDay"}
              initialDate={
                hotel.hotelCurrency === "INR"
                  ? new Date().toISOString()
                  : new Date(Date.now() - 3600 * 1000 * 24).toISOString()
              }
              eventAllow={() => false}
              selectable={true}
              events={initialData.bookingData}
              eventClick={handleDateSelect}
              resources={roomNumbers}
              resourceOrder={function (a, b) {
                return parseInt(a.initalId) < parseInt(b.initalId)
                  ? -1
                  : a.initalId > b.initalId
                  ? 1
                  : 0;
              }}
              stickyHeaderDates={"auto"}
              eventOverlap={true}
              select={addNew}
              ref={calendarRef}
              eventChange={handleDragStop}
              resourceAreaHeaderContent={"Spaces"}
              eventClassNames={(arg) => {
                if (arg.event.extendedProps.enquiry === "true") {
                  return ["fc-enquiry-event"];
                } else {
                  if (arg.event.extendedProps.status === "CONFIRMED") {
                    return ["fc-confirmed-event"];
                  }

                  if (arg.event.extendedProps.status === "CHECKED_OUT") {
                    return ["fc-checkedout-event"];
                  }

                  if (arg.event.extendedProps.status === "DONE") {
                    return ["fc-checkedout-event"];
                  }
                  if (arg.event.extendedProps.status === "BLOCKED")
                    return ["fc-blocked-event"];

                  if (arg.event.extendedProps.status === "COMBO")
                    return ["fc-combo-room"];
                  return ["timeline-calendar"];
                }
              }}
            />
            <Box>
              <Drawer anchor={"right"} open={show}>
                {actionType === "add" ? (
                  <CreateBooking
                    singleSpaceInfo={singleSpaceInfo}
                    hotelId={hotel.hotelId}
                    eventData={showModal}
                    onClose={() => {
                      setShow(false);
                    }}
                    fetchBookingData={fetchBookingData}
                  />
                ) : actionType === "edit" ? (
                  <ViewBooking
                    singleSpaceInfo={singleSpaceInfo}
                    hotelId={hotel.hotelId}
                    eventData={showModal}
                    onClose={() => {
                      setShow(false);
                    }}
                    fetchBookingData={fetchBookingData}
                  />
                ) : null}
              </Drawer>

              <Drawer anchor={"right"} open={openDrawer}>
                {multiOption === "booking" ? (
                  <CreateBooking
                    singleSpaceInfo={singleSpaceInfo}
                    hotelId={hotel.hotelId}
                    eventData={{}}
                    onClose={() => {
                      setOpenDrawer(false);
                      setMultiOption("");
                    }}
                    fetchBookingData={fetchBookingData}
                  />
                ) : multiOption === "groupBooking" ? (
                  <CreateGroupBooking
                    singleSpaceInfo={singleSpaceInfo}
                    hotelId={hotel.hotelId}
                    eventData={showModal}
                    onClose={() => {
                      setOpenDrawer(false);
                      setMultiOption("");
                    }}
                    fetchBookingData={fetchBookingData}
                  />
                ) : multiOption === "blocking" ? (
                  <BlockRoom
                    singleSpaceInfo={singleSpaceInfo}
                    hotelId={hotel.hotelId}
                    eventData={showModal}
                    onClose={() => {
                      setOpenDrawer(false);
                      setMultiOption("");
                    }}
                    fetchBookingData={fetchBookingData}
                  />
                ) : null}
              </Drawer>
            </Box>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};

function mapStateToProps(state) {
  return { datass: state.auth.selectedHotel, hotelType: state.auth.hotelType };
}
export default connect(mapStateToProps)(SpaceCalendar);
